import { makeApiCall } from '../core';
import type {
  ItemEnvelope,
  SubmitFeedbackRequest,
  SubmitFeedbackResponse,
} from '@ruta/shared';

/**
 * Submit in-app feedback / issue report. Lands as a Linear ticket (RUT-2602).
 */
export async function submitFeedback(
  request: SubmitFeedbackRequest,
): Promise<SubmitFeedbackResponse> {
  const res = await makeApiCall<ItemEnvelope<SubmitFeedbackResponse>>(
    'POST',
    '/feedback',
    request,
  );
  return res.data;
}
